<!-- 
  上部メニュー
-->
<template>
  <div>
    <div class="row header align-items-center" >
      <div class="col-auto">
        <img src="@/assets/acrypro/logo.svg" style="cursor: pointer" @click="backhome()" />
        <span class="deliv-text fw-bold">{{delivText}}</span><span class="acry-error-text fw-bold ms-3">{{sampleText}}</span>
      </div>
      <div class="col"></div>
      <div class="col-auto p-3 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowEdit && this.$store.state.tutorial.editStep == 2}">
        <button
          class="btn cart-btn fw-bold"
          :class="{ 'cart-open': this.$store.state.isShowCart }"
          style="width: 160px; height: 40px"
          @click="cartAction"
        >
          カート({{ this.$store.state.cartManager.getCartList().length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import router from "@/router";
import { CenterViewState } from "@/js/Const.js";

export default {
  name: "HomeTop_Ap",
  props: {},
  data: function () {
    return {
      allPrice: 0,
      delivText: "只今最短発送日 取得中",
    };
  },
  computed: {
    menuTitleFront() {
      if (this.$store.state.currentProduct) {
        if (
          this.$store.state.currentProduct.printInfo == "front" ||
          this.$store.state.currentProduct.printInfo == "frontback"
        ) {
          return "表面削除";
        } else {
          return "表面追加";
        }
      } else {
        return "表面追加";
      }
    },
    menuTitleBack() {
      if (this.$store.state.currentProduct) {
        if (
          this.$store.state.currentProduct.printInfo == "back" ||
          this.$store.state.currentProduct.printInfo == "frontback"
        ) {
          return "裏面削除";
        } else {
          return "裏面追加";
        }
      } else {
        return "裏面追加";
      }
    },
    menuTitleTag() {
      if (this.$store.state.currentProduct) {
        if (this.$store.state.currentProduct.tagInfo == "withTag") {
          return "タグ削除";
        } else {
          return "タグ追加";
        }
      } else {
        return "タグ追加";
      }
    },
    menuTitleGrid() {
      if (this.$store.state.currentProduct) {
        if (this.$store.state.isHiddenGrid) {
          return "グリッド表示";
        } else {
          return "グリッド非表示";
        }
      } else {
        return "グリッド表示";
      }
    },
    menuTitleControl() {
      if (this.$store.state.isShowControl) {
        return "コントロール非表示";
      } else {
        return "コントロール表示";
      }
    },
    menuTitlePreview() {
      if (this.$store.state.isShowLastPreview) {
        return "プレビュー非表示";
      } else {
        return "プレビュー表示";
      }
    },

    productMenuDisabled() {
      if (this.$store.state.currentProduct) {
        return false;
      } else {
        return true;
      }
    },
    tagHidden() {
      if (this.$store.state.currentProduct.productId != "4") {
        return true;
      } else {
        return false;
      }
    },
    sampleText(){
      return ([CenterViewState.SampleUpload, CenterViewState.SamplePreview].includes(this.$store.state.centerViewState))?"サンプル注文はこちらよりも発送が早まる場合があります":"";
    }
  },
  created: function () 
  {
    this.getDelivText();
  },
  components: {},
  methods: {
    onOver(ele) {
      this.$refs[ele].visible = true;
    },
    onLeave(ele) {
      this.$refs[ele].visible = false;
    },
    menuAction(num) {
      switch (num) {
        case 1: // アイテム追加
          this.addProductAction();
          break;
        case 2: // アイテム追加
          this.$store.state.mainCanvas.plusAction();
          break;
        case 3: // 表追加
          if (this.$store.state.currentProduct) {
            if (this.$store.state.currentProduct.printInfo == "back") {
              this.$store.state.mainCanvas.reverseAction();
            } else {
              if (this.$store.state.currentProduct.printInfo == "front") {
                this.$store.commit("removeProduct", this.$store.state.currentProduct);
              } else {
                this.$store.state.currentProduct.removeCanvasData(
                  this.$store.state.currentProduct.canvasDatas[0],
                  this.$store
                );
              }
            }
          }
          break;
        case 4: // 裏追加
          if (this.$store.state.currentProduct) {
            if (this.$store.state.currentProduct.printInfo == "front") {
              this.$store.state.mainCanvas.reverseAction();
            } else {
              if (this.$store.state.currentProduct.printInfo == "back") {
                this.$store.commit("removeProduct", this.$store.state.currentProduct);
              } else {
                this.$store.state.currentProduct.removeCanvasData(
                  this.$store.state.currentProduct.canvasDatas[1],
                  this.$store
                );
              }
            }
          }
          break;
        case 5: // タグ追加
          if (this.$store.state.currentProduct) {
            if (this.$store.state.currentProduct.tagInfo != "withTag") {
              this.$store.state.currentProduct.addTag();
            } else {
              this.$store.state.currentProduct.removeTag();
            }
          }
          break;
        case 6: // 履歴から追加
          this.$store.commit("showProductHistoryModal");
          break;
        case 7: // グリッド表示
          this.$store.commit("switchGrid");
          break;
        case 8: // コントロール表示
          if (this.$store.state.isShowControl) {
            this.$store.commit("hideControl");
          } else {
            this.$store.commit("showControl");
          }
          break;
        case 9: // プレビュー
          if (this.$store.state.isShowLastPreview) {
            this.$store.commit("hideLastPreview");
          } else {
            this.$store.commit("showLastPreview");
          }
          break;
        case 10: // マイページ
          this.showMypageAction();
          break;
        case 12: // FAQ
          this.showHelpAction();
          break;
        case 14: // タグ管理
          this.$store.commit("setMypageScreen", "tag");
          this.$store.commit("showMypageModal");
          break;
        case 15: // 注文履歴
          this.$store.commit("setMypageScreen", "orderhistory");
          this.$store.commit("showMypageModal");
          break;
        case 16: // 送付先追加
          this.$store.commit("setMypageScreen", "addDestination");
          this.$store.commit("showMypageModal");
          break;
        case 17: // 送付先編集
          this.$store.commit("setMypageScreen", "editDestination");
          this.$store.commit("showMypageModal");
          break;
        case 18: // 登録情報
          this.$store.commit("setMypageScreen", "editRegistInfo");
          this.$store.commit("showMypageModal");
          break;
        case 19: // 見積一覧
          this.$store.commit("showEstimatesList");
          break;
        case 20: // お問い合わせ
          router.push("/contact");
          break;
        case 50: // 中央に合わせる
          this.$store.state.currentCanvasData.currentItem.horizontalCenter();
          break;
        case 51: // 上部中央に合わせる
          this.$store.state.currentCanvasData.currentItem.topHrizontalCenter();
          break;
        case 52: // 初期サイズに戻す
          this.$store.state.currentCanvasData.currentItem.reset();
          break;
        case 53: // アートボードにサイズを合わせる
          this.$store.state.currentCanvasData.currentItem.adjustArtboard();
          break;
        case 99: // ログアウト
          this.$store.commit("setYesNoDialogCallback", this.logoutProcess);
          this.$store.commit("showYesNoDialog", "ログアウトしますか？");
          break;
      }
    },
    cartAction() {
      this.$store.commit("switchShowCart");
    },
    logoutProcess() {
      firebase
        .auth()
        .signOut()
        .then(function () {
          this.$store.commit("resetData");
          router.push("/");
        })
        .catch((error) => {
          this.$common.log(error.message);
          this.$store.commit("resetData");
          router.push("/");
        });
    },
    addProductAction: function () {
      this.$store.commit("showModal");
    },
    showMypageAction: function () {
      this.$store.commit("showMypageModal");
    },
    showHelpAction: function () {
      this.$store.commit("showHelp");
    },
    addItemAction: function () {
      this.$store.state.layerVue.plusAction();
    },
    getRipuValue: function () {
      if (this.$store.state.currentCanvasData) {
        if (this.$store.state.currentCanvasData.printInfo == "front") {
          return "" + (Number(this.$store.state.currentCanvasData.ripuValue) + 2) + " cm";
        } else if (this.$store.state.currentCanvasData.printInfo == "back") {
          return "" + (Number(this.$store.state.currentCanvasData.ripuValue) + 4) + " cm";
        }
      } else {
        return "0 cm";
      }
    },
    getPaintedWidth: function () {
      if (this.$store.state.currentCanvasData) {
        return "" + this.$store.state.currentCanvasData.paintedWidth;
      } else {
        return "0";
      }
    },
    getPaintedHeight: function () {
      if (this.$store.state.currentCanvasData) {
        return "" + this.$store.state.currentCanvasData.paintedHeight;
      } else {
        return "0";
      }
    },
    getAllPrice: function () {
      if (this.$store.state.currentProduct) {
        return (
          "" +
          (this.$store.state.currentProduct.getOnePrice() +
            this.$store.state.currentProduct.getOneMarginPrice())
        );
      } else {
        return "0";
      }
    },
    getTitle: function () {
      if (this.$store.state.currentProduct) {
        return "" + this.$store.state.currentProduct.getProductTitle();
      } else {
        return "";
      }
    },
    registData: function () {
      if (!this.$store.state.currentProduct || !this.$store.state.currentCanvasData) {
        return;
      }
      var cnt = 0;
      this.$store.commit("showLoading");

      this.$store.state.products.forEach((p) => {
        p.registDatabase().then(() => {
          cnt += 1;
          if (cnt >= this.$store.state.products.length) {
            this.$store.commit("hideLoading");
          }
        });
      });
    },
    backhome(){
      router.push("/");
    },
    async getDelivText() {
      const delivDate = await this.getDelivData();
      console.log("delivDate");
      let dt = new Date();
      console.log(dt);
      dt.setDate(dt.getDate() + delivDate);
      console.log(dt);
      this.delivText = `只今最短発送日 ${dt.getMonth()+1}月${dt.getDate()}日`;
    },
    async getDelivData() {
      const ref = firebase.firestore().collection("AcrySetting");
      const snapshot = await ref.where("type", "==", "deliverypro").get();
      const data = snapshot.docs[0].data();
      return parseInt(data.value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.deliv-text {
  margin-left: 40px;
  color: $text-main-color;
}

.cart-btn {
  color:  #8897be;
  background: white;
  border-radius: 20px;
  font-size: 16px;
  border: 3px solid $primary-main-color;
}
.cart-open {
  /* // margin: 10px; */
  padding-top: 7px;
  color: #ffffff;
  background: #8897be;
  font-size: 16px;
  border:none;
}
.cart-btn:hover {
  color: #8897be;
  background: #ffffff;
}
.cart-open:hover {
  color: #ffffff;
  background: #8897be;
}
.feature-ui{
  z-index: 5;
  pointer-events: none;
  background: white;
}
</style>
